import type { TInDirection } from '@/types/Common';

// --- Detection ---
export function isMirrorMac(macAddress: string): boolean {
  return macAddress.startsWith('mi-rr-or-');
}

export function isCloneMac(macAddress: string): boolean {
  return macAddress.startsWith('fa-ke-');
}

export function isVirtualMac(macAddress: string): boolean {
  return isMirrorMac(macAddress) || isCloneMac(macAddress);
}

/** Strip the mi-rr-or- or fa-ke- prefix from a virtual sensor MAC (counter couplet is preserved). */
export function stripVirtualMacPrefix(macAddress: string): string {
  return macAddress.replace(/^(mi-rr-or-|fa-ke-)/, '');
}

export function isVirtualSensor(sensor: { isMirror?: boolean; isClone?: boolean }): boolean {
  return sensor.isMirror === true || sensor.isClone === true;
}

// --- Naming ---
export function getDefaultMirrorName(sourceName: string): string {
  return `${sourceName} (Mirror)`;
}

export function getDefaultCloneName(sourceName: string): string {
  return `${sourceName} (Clone)`;
}

// --- Direction ---
export function flipInDirection(dir: TInDirection): TInDirection {
  return dir === 0 ? 1 : 0;
}
